"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUndefined = exports.isNoUndefined = void 0;
/** 判断数据是否是 undefined
 * @param { * } data 需要处理的命名
 * @return { Boolean } 返回判断结果
 */
var isUndefined = exports.isUndefined = function isUndefined(data) {
  return typeof data === 'undefined';
};

/** 判断数据不是 undefined
 * @param { * } data 需要处理的命名
 * @return { Boolean } 返回判断结果
 */
var isNoUndefined = exports.isNoUndefined = function isNoUndefined(data) {
  return !isUndefined(data);
};